module.exports = __webpack_public_path__ + "img/clem-onojeghuo.23321ebf.jpg";